import { IThreeVariantXP } from "@faire/web-api--source/indigofair/settings/IThreeVariantXP";
import { experiment } from "@faire/web/common/settings/declarations/experiment";

/**
 * Batch 12 Brand page CTA
 */
export const FE_BATCH_12_BRAND_PAGES_250811 = experiment({
  name: "FE_BATCH_12_BRAND_PAGES_250811",
  identifier: "SessionToken",
  client: ["RETAILER", "VISITOR_WEB"],
  notifyAfter: "2025-10-01",
  defaultValue: IThreeVariantXP.Bucket.CONTROL,
  productArea: "LOGGED_OUT_RETAILERS",
});
